import { useEffect, useMemo, useState } from 'react'

export function useCountdown(targetIso: string | null) {
  const target = useMemo(() => (targetIso ? new Date(targetIso).getTime() : null), [targetIso])
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 500)
    return () => clearInterval(t)
  }, [])

  const ms = target === null ? null : Math.max(0, target - now)
  const pretty = useMemo(() => {
    if (ms === null) return ''
    const s = Math.floor(ms / 1000)
    const d = Math.floor(s / 86400)
    const h = Math.floor((s % 86400) / 3600)
    const m = Math.floor((s % 3600) / 60)
    const ss = s % 60
    return `${d}d ${h}h ${m}m ${ss}s`
  }, [ms])

  return { ms, pretty, done: ms === 0 }
}
